import React, { useEffect, useContext } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Select,
  Button,
  MenuItem,
  InputLabel,
  Card,
  CardContent,
  IconButton,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { GetNotes, CustomerNotes, noteMeta } from "../utils/GetCustomer";
import { useParams } from "react-router-dom";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import {
  ExpandMore,
  Delete,
  Save,
  NoteAdd,
  Restore,
 } from "@mui/icons-material";
import { PostNotes } from "../utils/PostCustomer";

interface CustomerRouteParams {
  identifier: string;
}

interface CustomerNotesState {
  isLoaded: boolean;
  isCollapsed: boolean;
  notes: CustomerNotes[];
  meta?: noteMeta;
  modified:number[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      width: "100%",
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(0),
      margin:  theme.spacing(0),
    },
    gridMarginTop: {
    },
    chipImportant: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    deleted:{
      backgroundColor: theme.palette.grey[400]
    },
    restore:{
      backgroundColor: theme.palette.statusGreen.main,
      color: "White"
    }
  })
);
function formatDate(date:Date) {
  var d = new Date(date),
      month = '' + (d.getUTCMonth() + 1),
      day = '' + d.getUTCDate(),
      year = d.getUTCFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export default function CustomerNotesDisp() {
  const routeParams = useParams<CustomerRouteParams>();
  const classes = useStyles();
  const [state, setState] = React.useState<CustomerNotesState>({
    isLoaded: false,
    isCollapsed: true,
    notes: [],
    modified: [],
  });
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");

  const updateNote = (i:number,field:{isDeleted?:boolean,noteType?:string,isImportant?:boolean,validUntilDt?:Date,createdDt?:Date,createdBy?:string,text?:string}) =>{
    let newState = {...state};
    if(typeof field.isDeleted !== 'undefined') 
        newState.notes[i].isDeleted = field.isDeleted
    if(typeof field.noteType !== 'undefined') 
        newState.notes[i].noteType = field.noteType
    if(typeof field.isImportant !== 'undefined') 
        newState.notes[i].isImportant = field.isImportant
    if(typeof field.validUntilDt !== 'undefined') 
        newState.notes[i].validUntilDt = field.validUntilDt
    if(typeof field.createdDt !== 'undefined') 
        newState.notes[i].createdDt = field.createdDt
    // if(typeof field.createdBy !== 'undefined') 
    //     newState.notes[i].createdBy = field.createdBy
    if(typeof field.text !== 'undefined') 
      newState.notes[i].text = field.text.substring(0,state.meta?.maxLength||300)
    newState.modified.push(i)
    setState(newState);
  }

  const newNote = ()=>{
    let newState = {...state};
    let newNote:CustomerNotes = {
      noteType:"DRIVER",
      text:"",
      isDeleted:false,
      isImportant:false,
      validUntilDt:new Date(),
      createdBy:"",
      createdDt:new Date()
    }
    newState.modified = [0].concat(newState.modified.map(i=>i++))
    newState.notes = [newNote].concat(state.notes);
    setState(newState);
  }
  const handleSave = ()=>{    
    let modified = Array.from((new Set(state.modified)));

    //console.log(modified);
    if(typeof modified !== 'undefined' && modified.length > 0){
      let toSave: CustomerNotes[] = [];
      modified.forEach(i =>{toSave.push(state.notes[i]);})
      PostNotes(salesOrg.toString(), routeParams.identifier, toSave)
        .then( v=>{
          setState({
            ...state,
            isLoaded: true,
            notes: v?.notes,
            meta: v?.noteMeta,
            modified:[],
          });
        });
    }
  }

  useEffect(() => {
    if(state.isLoaded) { 
      return;
    }
    GetNotes(salesOrg.toString(), routeParams.identifier).then(
      (v) => {
        setState({
          ...state,
          isLoaded: true,
          notes: v?.notes,
          meta: v?.noteMeta,
          modified:[],
        });
      }
    );
  }, [state.isLoaded, routeParams.identifier, state.modified, state, salesOrg]);

  if (!state.isLoaded) return <div />;

  return (
    
    <Accordion className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.gridMarginTop}>
          Notes ({state.notes.length})
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Card className={classes.divWidth}>
          <div className={classes.divWidth}>
            <Stack direction="row" spacing={2}>
              <Button
                className={classes.paragraphButton}
                color="primary"
                variant="contained"
                onClick={newNote} >
                  <NoteAdd /> New Note
              </Button>
              <Button
                className={classes.paragraphButton}
                color="primary"
                variant="contained"
                disabled={state.modified.length === 0}
                onClick={handleSave} >
                  <Save /> Save
              </Button>
            </Stack>
          </div>
            {state.notes.map((n,i) => (
              <div className={classes.divWidth}>
                <Card className={n.isDeleted?classes.deleted:classes.divWidth} style={{minWidth:500}}>
                  <CardContent>
                    {/* //// Important not supported by SAP, so disabled for now. 
                    {n.isDeleted?(<Chip
                      label="To Delete"
                      className={classes.chipImportant}
                      icon={<Delete />}
                      color="primary"
                    />):(<div></div>)}
                    <Chip
                      label={(n.isImportant)?"Important":""}
                      className={classes.chipImportant}
                      icon={(n.isImportant)?(<Error />):(<FiberManualRecordOutlined />)}
                      color={(n.isImportant)?"primary":"default"}
                      onClick={()=>updateNote(i,{isImportant:!(n.isImportant)})}
                    />
                    */}
                    <div className={classes.divWidth} style={{textAlign:"right"}}>
                      {(n.isDeleted)?(
                        <IconButton key="restore" aria-label="restore"  onClick={()=>updateNote(i,{isDeleted:false})} className={classes.restore}>
                          <Restore />
                        </IconButton>
                      ):(
                        <IconButton  key="delete" aria-label="delete"  onClick={()=>updateNote(i,{isDeleted:true})} color="primary">
                          <Delete />
                        </IconButton>
                      )}


                    </div>
                    <Grid container spacing={2} className={classes.gridMarginTop}>
                      <Grid item lg={2} xs={2} className={classes.gridSpaceable}>
                        <InputLabel >Note Type</InputLabel>
                        <Select 
                          label="Note Type" 
                          value={n.noteType}
                          disabled={n.isDeleted}
                          onChange={(ce:any) => {
                            // ce.persist();
                            updateNote(i,{noteType:(typeof ce.target.value == "string"?ce.target.value:"")})}}
                        >
                          {state.meta?.validTypes.map(vt=>(
                            <MenuItem value={vt.code}>{vt.text}</MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item lg={2} xs={2} className={classes.gridSpaceable}>
                        <TextField
                          fullWidth={true}
                          label="Valid From"
                          type="date"
                          disabled={n.isDeleted}
                          value={formatDate(n.createdDt)}
                          onChange={(ce:any)=>{ 
                            // ce.persist();
                            updateNote(i,{createdDt:new Date(ce.target.value)})}}
                          />
                      </Grid>
                      <Grid item lg={2} xs={2} className={classes.gridSpaceable}>
                        <TextField
                          fullWidth={true}
                          type="date"
                          disabled={n.isDeleted}
                          label="Valid Until"
                          onChange={(ce)=>{
                            ce.persist();
                            updateNote(i,{validUntilDt:new Date(ce.target.value)})}}
                          value={formatDate(n.validUntilDt)}
                          />
                      </Grid>
                      <Grid item lg={4} xs={4} className={classes.gridSpaceable}>
                        <TextField
                          contentEditable={false}
                          fullWidth={true}
                          disabled={n.isDeleted}
                          label="Created By"
                          value={n.createdBy}
                          onChange={(ce:any)=>{ ce.persist();
                            updateNote(i,{createdBy:ce.target.value})}}
                          />
                      </Grid>
                    </Grid>
                    <Grid item lg={10} xs={10} >
                        <TextField
                          fullWidth={true}
                          multiline
                          rows={3}
                          disabled={n.isDeleted}
                          label="Note"
                          value={n.text}
                          onChange={(ce:any)=>{
                            ce.persist();
                            updateNote(i,{text:ce.target.value})}}
                          />
                      </Grid>
                  </CardContent>
                </Card>
              </div>
            ))}    
        </Card>
      </AccordionDetails>
    </Accordion>

  );
}
